import type { Messages } from '@/i18n/types';

export const ru: Messages = {
  'nav.today': 'Сегодня',
  'nav.history': 'История',
  'nav.calendar': 'Календарь',
  'nav.timelapse': 'Таймлапс',
  'nav.settings': 'Настройки',

  'common.loading': 'Загрузка…',
  'common.sign_out': 'Выйти',
  'common.cancel': 'Отмена',
  'common.api_unreachable': 'Не удалось связаться с API: {message}',

  'capture.today': 'Сегодня',
  'capture.streak': {
    one: '{n} день подряд',
    few: '{n} дня подряд',
    many: '{n} дней подряд',
    other: '{n} дня подряд',
  },
  'capture.checking_today': 'Проверяем сегодняшний день…',
  'capture.opening_camera': 'Открываем камеру…',
  'capture.shutter': 'Сделать фотографию',
  'capture.uploading': 'Загружаем…',
  'capture.gallery': 'Выбрать из галереи',
  'capture.photo_alt': 'Сегодняшнее селфи',
  'capture.upload_failed': 'Загрузка не прошла.',
  'capture.processing': 'Обрабатываем…',
  'capture.done': 'На сегодня всё. До завтра.',
  'capture.status': 'Статус: {status}',
  'capture.status_pending': 'ожидает',
  'capture.status_processing': 'обрабатывается',
  'capture.status_ready': 'готово',
  'capture.status_failed': 'не удалось',
  'capture.hint_unavailable':
    'Выравнивание лица отключено — фотография сохранится как есть.',
  'capture.hint_loading': 'Загружаем выравнивание лица…',
  'capture.hint_outline': 'Совместите лицо с контуром.',
  'capture.hint_searching': 'Ищем ваше лицо…',
  'capture.hint_closer': 'Подойдите ближе и держите голову ровно.',

  'history.title': 'История',
  'history.count': {
    one: 'уже {n} день',
    few: 'уже {n} дня',
    many: 'уже {n} дней',
    other: 'уже {n} дня',
  },
  'history.subtitle_empty': 'Каждый день, когда вы пришли.',
  'history.empty': 'Здесь пока пусто. Первая фотография начнёт таймлапс.',
  'history.load_failed': 'Не удалось загрузить историю: {message}',
  'history.loading_more': 'Загружаем ещё…',

  'calendar.subtitle': 'Календарь привычки',
  'calendar.filled': {
    one: '{filled} из {n} дня',
    few: '{filled} из {n} дней',
    many: '{filled} из {n} дней',
    other: '{filled} из {n} дней',
  },
  'calendar.previous_month': 'Предыдущий месяц',
  'calendar.next_month': 'Следующий месяц',
  'calendar.load_failed': 'Не удалось загрузить этот месяц: {message}',
  'calendar.mon': 'Пн',
  'calendar.tue': 'Вт',
  'calendar.wed': 'Ср',
  'calendar.thu': 'Чт',
  'calendar.fri': 'Пт',
  'calendar.sat': 'Сб',
  'calendar.sun': 'Вс',

  'timelapse.title': 'Таймлапс',
  'timelapse.subtitle': 'Посмотрите, как прошёл год.',
  'timelapse.range': 'Период',
  'timelapse.range_week': 'Неделя',
  'timelapse.range_month': 'Месяц',
  'timelapse.range_year': 'Год',
  'timelapse.range_all': 'Всё время',
  'timelapse.render': 'Собрать',
  'timelapse.rendering': 'Собираем…',
  'timelapse.progress_label': 'Ход сборки',
  'timelapse.frames': {
    one: '{done} из {n} кадра',
    few: '{done} из {n} кадров',
    many: '{done} из {n} кадров',
    other: '{done} из {n} кадров',
  },
  'timelapse.on_server':
    'Этот браузер не умеет кодировать видео, поэтому его собирает сервер…',
  'timelapse.download': 'Скачать',
  'timelapse.local': 'Собрано на вашем устройстве — оно его не покидало.',
  'timelapse.render_failed': 'Не удалось собрать видео.',
  'timelapse.start_failed': 'Не удалось запустить сборку.',

  'settings.title': 'Настройки',
  'settings.remind_at': 'Напоминать в',
  'settings.update_timezone': 'обновить с {zone}',
  'settings.how': 'Как',
  'settings.channel_both': 'Push и почта',
  'settings.channel_both_hint': 'Что дойдёт первым.',
  'settings.channel_push': 'Только push',
  'settings.channel_push_hint': 'На iOS нужно установить приложение.',
  'settings.channel_email': 'Только почта',
  'settings.channel_email_hint': 'Работает везде.',
  'settings.channel_off': 'Выключено',
  'settings.channel_off_hint': 'Никаких напоминаний.',
  'settings.language': 'Язык',
  'settings.language_hint': 'На нём же приходят письма с напоминаниями.',
  'settings.this_device': 'Это устройство',
  'settings.push_enable': 'Включить push на этом устройстве',
  'settings.push_disable': 'Отключить push на этом устройстве',
  'settings.push_denied':
    'Уведомления для этого сайта заблокированы в настройках браузера. Напоминания по почте продолжают работать.',
  'settings.push_unsupported':
    'Этот браузер не умеет получать push-уведомления. На iPhone сначала добавьте Selflapse на домашний экран. Напоминания по почте работают в любом случае.',

  'auth.email': 'Электронная почта',
  'auth.password': 'Пароль',
  'auth.name': 'Имя',
  'auth.confirm_password': 'Подтверждение пароля',
  'auth.login_title': 'С возвращением',
  'auth.login_subtitle': 'Одно селфи в день.',
  'auth.sign_in': 'Войти',
  'auth.signing_in': 'Входим…',
  'auth.create_account_link': 'Создать аккаунт',
  'auth.forgot_link': 'Забыли пароль',
  'auth.register_title': 'Начните свой таймлапс',
  'auth.register_subtitle': 'Ваш календарный день считается по зоне {zone}.',
  'auth.have_account': 'У меня уже есть аккаунт',
  'auth.consent': 'Я согласен на хранение и обработку фотографий моего лица в Selflapse.',
  'auth.create_account': 'Создать аккаунт',
  'auth.creating_account': 'Создаём аккаунт…',
  'auth.forgot_title': 'Сброс пароля',
  'auth.forgot_subtitle': 'Мы отправим ссылку на почту.',
  'auth.back_to_sign_in': 'Вернуться ко входу',
  'auth.send_link': 'Отправить ссылку',
  'auth.sending': 'Отправляем…',
  'auth.reset_title': 'Придумайте новый пароль',
  'auth.new_password': 'Новый пароль',
  'auth.save_password': 'Сохранить пароль',
  'auth.saving': 'Сохраняем…',
  'auth.reset_done': 'Теперь можно войти.',
  'auth.link_incomplete_title': 'Ссылка неполная',
  'auth.link_incomplete': 'В ссылке для сброса нет токена. Запросите новую.',
  'auth.request_new_link': 'Запросить новую ссылку',
  'auth.check_email':
    'Аккаунт создан. Откройте ссылку из письма на {email}, чтобы завершить, и затем войдите.',
  'auth.check_email_hint':
    'Письма нет? Оно может идти минуту, а спам-фильтры настороженно относятся к новым отправителям.',
  'auth.verified_ok': 'Адрес подтверждён. Теперь можно войти.',
  'auth.verified_already': 'Этот адрес уже был подтверждён. Можно входить.',
  'auth.verified_invalid':
    'Эта ссылка для подтверждения больше не действует. Войдите, и мы отправим новую.',
  'auth.resend_verification': 'Отправить новую ссылку',

  'push.title': 'Пора сделать сегодняшнее селфи',
  'push.body': 'Одна фотография сохранит серию.',

  'health.subtitle': 'Состояние локального окружения',
  'health.checking': 'Проверяем сервисы…',
  'health.unreachable': 'API недоступен: {message}',
  'health.ok': 'Всё работает',
  'health.degraded': 'Работает частично',

  'errors.camera_unsupported': 'Этот браузер не может открыть камеру.',
  'errors.camera_denied':
    'Доступ к камере заблокирован. Можно загрузить фотографию из галереи.',
  'errors.camera_unavailable': 'На этом устройстве нет доступной камеры.',
  'errors.camera_not_ready': 'Превью камеры ещё не готово.',
  'errors.push_unsupported': 'Этот браузер не умеет получать push-уведомления.',
  'errors.push_blocked':
    'Уведомления для этого сайта заблокированы. Напоминания по почте продолжают работать.',
  'errors.push_not_configured': 'Push пока не настроен на сервере.',
  'errors.push_failed': 'Не удалось изменить push на этом устройстве.',
  'errors.save_failed': 'Не удалось сохранить настройку.',
  'errors.canvas_context': 'Не удалось получить контекст рисования 2D.',
  'errors.encode_failed': 'Браузер не смог закодировать снятый кадр.',
  'errors.no_frame': 'Камера ещё не выдала ни одного кадра.',
  'errors.upload_failed': 'Не удалось загрузить фотографию в хранилище.',
  'errors.photo_not_ready': 'Фотография от {date} ещё не готова.',
  'errors.photo_load_failed': 'Не удалось загрузить фотографию от {date}.',
  'errors.range_empty': 'За этот период ещё нет фотографий.',
  'errors.encoder_empty': 'Кодировщик ничего не выдал.',
  'errors.request_failed': 'Запрос к {path} не удался',
};
